/**
 * What the analyzer chart paints, from the answer on screen (CU-869fmm949). Computed on every render from the props:
 * the chart used to freeze the series and rows of the answer it was mounted with (`useComputed` / `useSignal` keep
 * their first closure), so an answer that arrives without remounting it — Min / Max and the Cars selector keep the
 * card on screen — was painted with the series and the prices of the previous one: the main provider's line was
 * missing when the previous answer had none (a Web answer, or a car it does not offer). Pure: `node --test` runs it.
 */

/** The series of a mode: Price values → the prices (no previous-period ` Pr…` keys, no ` diff`); else the ` diff`. */
export function chartSeries(keySeries, mode = 'price') {
	const all = (keySeries || []).filter(s => s && typeof s.dataKey === 'string')
	if (mode !== 'price') return all.filter(({ dataKey }) => dataKey.includes('diff'))
	return all.filter(({ dataKey }) => !dataKey.includes(' Pr') && !dataKey.includes('diff'))
}

/** The rows painted: all, or the one of the site picked in the chart's own filter (Rating), by its label. */
export function chartRows(chartData, siteLabel = null) {
	const rows = chartData || []
	return siteLabel ? rows.filter(({ date }) => date === siteLabel) : rows
}
